import { css } from 'lit';

export const styles = [
  css`
    :where(dialog) {
      overflow: visible;
    }

    :host([inline='true']) {
      display: inline-block;
      vertical-align: middle;
    }

    ::slotted(img) {
      block-size: auto;
      cursor: grab;
      display: block;
      max-block-size: 90vh;
      max-inline-size: 100%;
    }

    ::slotted(img[slot='trigger']) {
      cursor: zoom-in;
    }
  `,
];
